export default "__VITE_ASSET__Du58ID6p__"